// components
import { Container } from 'components/Grid';

// styles
import {
  Title,
  Paragraph,
  ButtonPrimary,
  ButtonSecondary,
  PageWrapper,
} from './TextBlock.styles';

export const TextBlock = ({ content }) => {
  return (
    <PageWrapper className={content.inverted ? 'inverted' : ''}>
      <Container>
        <Title className={content.inverted ? 'inverted' : ''}>
          {content.title}
        </Title>
        <Paragraph className={content.inverted ? 'inverted' : ''}>
          {content.description}
        </Paragraph>
        {content.inverted ? (
          <ButtonPrimary
            target={content.CTA.external ? `_blank` : ``}
            rel={content.CTA.external ? `noreferrer noopener` : ``}
            as="a"
            href={content.CTA.link}
          >
            {content.CTA.label}
          </ButtonPrimary>
        ) : (
          <ButtonSecondary
            target={content.CTA.external ? `_blank` : ``}
            rel={content.CTA.external ? `noreferrer noopener` : ``}
            as="a"
            href={content.CTA.link}
          >
            {content.CTA.label}
          </ButtonSecondary>
        )}
      </Container>
    </PageWrapper>
  );
};
